import { render, staticRenderFns } from "./PlanoTabelaGradeAntiga.vue?vue&type=template&id=1a0c35a0&scoped=true&"
import script from "./PlanoTabelaGradeAntiga.vue?vue&type=script&lang=js&"
export * from "./PlanoTabelaGradeAntiga.vue?vue&type=script&lang=js&"
import style0 from "./PlanoTabelaGradeAntiga.vue?vue&type=style&index=0&id=1a0c35a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c35a0",
  null
  
)

export default component.exports